module.exports = __webpack_public_path__ + "media/images/img_service_step_5-88a633182be5f6d716479b03a64b9c33.png";